<template>
    <v-dialog
        v-model="AppLoader.isShowing"
        persistent
        width="25%"
    >
        <v-card
            color="primary"
            dark
        >
            <v-card-text>
                {{AppLoader.message}}
                <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                ></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import AppLoader from '../models/App.Loader'

export default {
    data(){
        return {
            AppLoader
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
